import { Injectable, signal } from '@angular/core';

export type Lang = 'en' | 'ru';

export interface LanguageInfo {
  code: Lang;
  label: string;
  flag: string;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly STORAGE_KEY = 'lang';
  private readonly DEFAULT: Lang = 'en';

  readonly languages: LanguageInfo[] = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'ru', label: 'Русский', flag: '🇷🇺' }
  ];

  readonly currentLang = signal<Lang>(this.load());

  getCurrentInfo(): LanguageInfo {
    return this.languages.find(l => l.code === this.currentLang()) ?? this.languages[0];
  }

  setLang(lang: Lang): void {
    if (lang === this.currentLang()) return;
    localStorage.setItem(this.STORAGE_KEY, lang);
    location.reload();
  }

  private load(): Lang {
    const stored = localStorage.getItem(this.STORAGE_KEY) as Lang | null;
    if (stored && this.languages.some(l => l.code === stored)) return stored;
    return this.DEFAULT;
  }
}
